/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSubEvaluationRatingOutputDimGrades } from './oralExamSubEvaluationRatingOutputDimGrades';
import type { OralExamSubEvaluationRatingOutputQuestionFeedback } from './oralExamSubEvaluationRatingOutputQuestionFeedback';

/**
 * Per-question rating. question_feedback round-trips via dim_comments[questionId] in DB.
 */
export interface OralExamSubEvaluationRatingOutput {
  dimGrades: OralExamSubEvaluationRatingOutputDimGrades;
  questionFeedback?: OralExamSubEvaluationRatingOutputQuestionFeedback;
}
